import { DpaLocalAudience } from '@tt4b/ttam-enums';

// 人群包类型
export const AUDIENCE_TYPE = {
  NORMAL: {
    i18n: 'module_adgroup_find_prospective_customers',
    value: DpaLocalAudience.Normal,
    hint: 'module_adgroup_find_prospective_customers_hint',
    disableHint: 'module_adgroup_find_prospective_customers_disabled_hint',
  },
  RETARGET: {
    i18n: 'module_dpa_ad_retarget',
    value: DpaLocalAudience.Retarget,
    hint: 'module_dpa_ad_retarget_hint',
    disableHint: 'module_dpa_ios14_retargeting_disable_hint',
  },
};

export const DPA_RETARGET_OPTIONS = [
  {
    label: 'module_dpa_ad_custom_viewed',
    value: 4002,
  },
  {
    label: 'module_dpa_ad_custom_added',
    value: 4003,
  },
  {
    label: 'module_dpa_ad_custom_purchased',
    value: 4006,
  },
];
